/* eslint-disable */
// @ts-nocheck

import bigDecimal from 'js-big-decimal'
import React, { useEffect, useState } from 'react'
import { FaRegFilePdf } from 'react-icons/fa'
import { TbTransform } from 'react-icons/tb'

import {
  ArrowsRightLeftIcon,
  CheckIcon,
  NoSymbolIcon,
} from '@heroicons/react/24/outline'

import useServerArea from '../../../../api/useServerArea'
import useServer from '../../../../api/useServerMain'
import GenericList from '../../../../components/misc/GenericList'
import Modal from '../../../../components/misc/GenericModal'
import GenericTable, {
  DataTableInterface,
} from '../../../../components/misc/GenericTable'
import LoadingSpin from '../../../../components/misc/LoadingSpin'
import MultipleActBtn, {
  BtnActions,
} from '../../../../components/misc/MultipleActBtn'
import SpinnerLoading from '../../../../components/misc/SpinnerLoading'
import { DispatchStatus } from '../../../../interfaces/ServerInterfaces'
import reportDowloadHandler from '../../../../reports/helpers/reportDownloadHandler'
import { useAppSelector } from '../../../../store/hooks'
import { printPriceWithCommasAndPeriods } from '../../../../utils/functions'
import { formatCalendar } from '../../../../utils/helpers'
import { translateMeasure } from '../../../../utils/translate'
import TransformToBill from './TransformToBill'
import { TransformToDispatch } from './TransformToDispatch'

interface DetailProps {
  id: number | null
  response?: (
    id: number,
    response: DispatchStatus,
    isPreDispatch: boolean,
    payload?: Record<string, any>,
    closeModal?: Function
  ) => void
  loading?: DispatchStatus
}

const DetailDispatch = ({ id, response, loading }: DetailProps) => {
  const { allowRoles, denyRoles } = useServer()
  const { getDispatch, despacho, isLoading } = useServerArea()
  const { business } = useAppSelector((state) => state.init)
  const [respState, setRespState] = useState<DispatchStatus | null>(null)
  const [transform, setTransform] = useState(false)
  const [transformToDispatch, setTransformToDispatch] = useState(false)

  useEffect(() => {
    getDispatch(id!)
  }, [])

  //Data for List DispatchReport ---------------------------------------------------------------------------------
  const productData: DataTableInterface[] = []
  const products: {
    id: number
    name: string
    measure: string
    quantity: number
    variations: { id: number; name: string; quantity: number }[]
    product: {
      enableGroup: null | boolean
      groupConvertion: number | null
      groupName: null | string
      id: number
      name: string
    }
    price: {
      amount: number
      codeCurrency: string
    }
    cost: {
      amount: number
      codeCurrency: string
    }
  }[] = []
  despacho?.products.forEach((prod: any) => {
    const idx = products.findIndex((elem) => elem.id === prod.productId)
    if (idx !== -1) {
      const current = products[idx]
      products.splice(idx, 1, {
        ...current,
        quantity: current.quantity + (prod?.quantity ?? 0),
        variations: prod?.variation
          ? [
              ...current.variations,
              {
                id: prod.variation.id,
                name: prod.variation.name,
                quantity: prod.quantity,
              },
            ]
          : [...current.variations],
        product: {
          enableGroup: prod?.product?.enableGroup,
          groupConvertion: prod.product?.groupConvertion,
          groupName: prod.product?.groupName,
          id: prod.product?.id,
          name: prod.product?.name,
        },
      })
    } else {
      products.push({
        id: prod.productId,
        name: prod.name,
        quantity: prod.quantity,
        measure: prod.measure,
        variations: prod.variation
          ? [
              {
                id: prod.variation.id,
                name: prod.variation.name,
                quantity: prod.quantity,
              },
            ]
          : [],
        product: {
          enableGroup: prod?.product?.enableGroup,
          groupConvertion: prod.product?.groupConvertion,
          groupName: prod.product?.groupName,
          id: prod.product?.id,
          name: prod.product?.name,
        },
        price: {
          amount: prod?.price?.amount ?? 0,
          codeCurrency: prod?.price?.codeCurrency ?? '',
        },
        cost: {
          amount: prod?.cost?.amount ?? 0,
          codeCurrency: prod?.cost?.codeCurrency ?? '',
        },
      })
    }
  })

  const total = products.reduce((acc: any, item: any) => {
    const { amount, codeCurrency } = item.cost

    // Buscar si ya existe un objeto en el acumulador con la misma moneda
    const existingCurrency: any = acc.find(
      (entry: { codeCurrency: any }) => entry.codeCurrency === codeCurrency
    )

    const productCostAmount = new bigDecimal(amount)
    const productQuantity = new bigDecimal(item.quantity)

    const totalCost = productCostAmount.multiply(productQuantity).getValue()

    if (existingCurrency) {
      // Si existe, sumar el monto al existente
      existingCurrency.price += Number(totalCost)
    } else {
      // Si no existe, agregar un nuevo objeto al acumulador
      acc.push({ price: Number(totalCost), codeCurrency })
    }

    return acc
  }, [])

  const totalMeasure = products.reduce((acc: any, item: any) => {
    const { quantity, measure } = item

    // Buscar si ya existe un objeto en el acumulador con la misma moneda
    const existingCurrency: any = acc.find(
      (entry: { measure: any }) => entry.measure === measure
    )

    if (existingCurrency) {
      // Si existe, sumar el monto al existente
      existingCurrency.quantity += quantity
    } else {
      // Si no existe, agregar un nuevo objeto al acumulador
      acc.push({ quantity, measure })
    }

    return acc
  }, [])

  products.forEach((item) => {
    const quantityByGroup: (quantity: number) => React.ReactElement | void = (
      quantity
    ) => {
      if (item?.product?.enableGroup) {
        const rest = quantity % (item?.product?.groupConvertion! ?? 1)
        return (
          <div className="flex-col">
            <div>
              {`${Math.trunc(
                quantity / (item?.product?.groupConvertion! ?? 1)
              )} ${item?.product?.groupName ?? ''}`}
            </div>
            {rest !== 0 && (
              <p>{'(+' + rest + translateMeasure(item.measure) + ')'}</p>
            )}
          </div>
        )
      }
    }

    const productCostAmount = new bigDecimal(item.cost.amount)
    const productQuantity = new bigDecimal(item.quantity)

    const totalCost = productCostAmount.multiply(productQuantity).getValue()

    return productData.push({
      rowId: item.id,
      payload: {
        Productos: item.name,
        'Costo unitario':
          printPriceWithCommasAndPeriods(item.cost.amount) +
          ' ' +
          item.cost.codeCurrency,
        'Costo total':
          printPriceWithCommasAndPeriods(Number(totalCost)) +
          ' ' +
          item.cost.codeCurrency,
        Cantidades: (
          <div className="font-semibold">
            <div>{`${item.quantity} ${translateMeasure(item?.measure)}`}</div>
          </div>
        ),
        Agrupación: (
          <div className="font-semibold">
            {!!quantityByGroup(item.quantity) &&
              !!item.product?.groupConvertion && (
                <div>{`${item.quantity / item.product?.groupConvertion} ${item.product?.groupName}`}</div>
              )}
          </div>
        ),
      },
      childRows:
        item.variations.length !== 0
          ? item.variations.map((variation) => ({
              payload: {
                Productos: variation.name,
                Cantidades: variation.quantity,
                Agrupación: '',
              },
            }))
          : undefined,
    })
  })

  productData.push({
    payload: {
      Productos: 'TOTAL',
      'Costo unitario': ' ',
      'Costo total': total
        .map(
          (item: { price: any; codeCurrency: any }) =>
            `${printPriceWithCommasAndPeriods(item.price)}${item.codeCurrency}`
        )
        .join('   '),
      Cantidades: (
        <div className="flex flex-col">
          {totalMeasure.map(
            (item: { quantity: any; measure: any }, idx: number) => (
              <p className="font-semibold" key={idx}>
                {`${item.quantity}${translateMeasure(item.measure)}`}
              </p>
            )
          )}
        </div>
      ),
      Agrupación: <div className="flex flex-col"></div>,
    },
    childRows: undefined,
  })

  const listHeader = {
    title: `${despacho?.isPreDispatch ? 'Pre Despacho' : 'Despacho'}`,
  }
  const dataToDisplay: Record<string, string | number | React.ReactNode> = {
    Origen: despacho?.stockAreaFrom?.name ?? '-',
    Destino: despacho?.stockAreaTo.name,
    'Enviado por:':
      despacho?.createdBy?.displayName +
      ' ' +
      formatCalendar(despacho?.createdAt, true),
    'No. pedido': despacho?.id,
  }
  const actionsBtn: BtnActions[] = []
  actionsBtn.push({
    title: 'Generar PDF',
    icon: <FaRegFilePdf className="h-5 text-gray-500" />,
    action: (close) => {
      reportDowloadHandler(
        despacho?.isPreDispatch
          ? 'PreDespacho de mercancías'
          : 'Transferencia/Despacho de mercancías',
        'dispatch',
        business!,
        despacho
      )
      close()
    },
  })
  if (denyRoles(['AUDITOR'])) {
    if (
      despacho?.status === 'CREATED' &&
      !!response &&
      business?.id === despacho.stockAreaTo?.business?.id
    ) {
      if (
        allowRoles(['ADMIN', 'MANAGER_SALES', 'MANAGER_SHIFT']) &&
        despacho.isPreDispatch
      ) {
        actionsBtn.push({
          title: 'Transformar a despacho',
          action: (close) => {
            setTransformToDispatch(true)
            close()
          },
          icon: <ArrowsRightLeftIcon className="h-5" />,
        })
      }
      if (respState !== 'ACCEPTED')
        actionsBtn.push({
          icon:
            loading === 'ACCEPTED' ? (
              <LoadingSpin color="slate-600" />
            ) : (
              <CheckIcon className="h-5 text-slate-600" />
            ),
          action: () => {
            setRespState('ACCEPTED')
            response(despacho.id, 'ACCEPTED', despacho.isPreDispatch)
          },
          title: `Aceptar ${despacho.isPreDispatch ? 'pre despacho' : 'despacho'}`,
        })

      if (
        allowRoles(['ADMIN', 'MANAGER_SALES', 'MANAGER_SHIFT']) &&
        !despacho.isPreDispatch &&
        respState !== 'ACCEPTED'
      ) {
        actionsBtn.push({
          title: 'Convertir en factura',
          action: (close) => {
            setRespState('BILLED')
            setTransform(true)
            close()
          },
          icon: <TbTransform />,
        })
      }
    }

    if (
      (['CREATED', 'BILLED'] as (DispatchStatus | undefined)[]).includes(
        despacho?.status
      ) &&
      !!response &&
      respState !== 'ACCEPTED'
    ) {
      actionsBtn.push({
        icon:
          loading === 'REJECTED' && respState === 'REJECTED' ? (
            <LoadingSpin color="slate-600" />
          ) : (
            <NoSymbolIcon className="h-5 text-slate-600" />
          ),
        action: () => {
          setRespState('REJECTED')
          response(id!, 'REJECTED', despacho?.isPreDispatch!)
        },
        title: `Cancelar ${
          despacho?.isPreDispatch ? 'pre despacho' : 'despacho'
        }`,
      })
    }
  }

  if (despacho?.status === 'REJECTED') {
    dataToDisplay['Rechazado por'] =
      despacho.rejectedBy?.displayName +
      ' ' +
      formatCalendar(despacho?.rejectedAt ?? ' ', true)
  }

  if (despacho?.status === 'ACCEPTED') {
    dataToDisplay['Recibido por'] =
      despacho.receivedBy?.displayName +
      ' ' +
      formatCalendar(despacho?.receivedAt ?? ' ', true)
  }

  if (despacho?.observations) {
    dataToDisplay['Observaciones'] = despacho?.observations
  }

  dataToDisplay['Listado de Productos:'] = (
    <GenericTable
      tableData={productData}
      tableTitles={
        allowRoles(['MANAGER_COST_PRICES', 'OWNER'], true)
          ? despacho?.isPreDispatch
            ? ['Productos', 'Cantidades', 'Agrupación']
            : [
                'Productos',
                'Costo unitario',
                'Costo total',
                'Cantidades',
                'Agrupación',
              ]
          : ['Productos', 'Cantidades', 'Agrupación']
      }
    />
  )

  const actionToTransform = (payload: Record<string, any>) => {
    response!(id!, 'BILLED', despacho?.isPreDispatch!, payload, () =>
      setTransform(false)
    )
  }

  if (isLoading)
    return (
      <div className="flex h-96 flex-col items-center justify-center">
        <SpinnerLoading />
      </div>
    )
  return (
    <div className="relative h-96 overflow-auto py-5 pr-5 scrollbar-none">
      <div className="absolute right-12 top-8">
        <MultipleActBtn items={actionsBtn} />
      </div>
      <GenericList body={dataToDisplay} header={listHeader} />
      {transform && (
        <Modal close={setTransform} state={transform}>
          <TransformToBill
            action={actionToTransform}
            loading={!!loading && respState === 'BILLED'}
          />
        </Modal>
      )}
      {transformToDispatch && (
        <Modal
          close={setTransformToDispatch}
          size="m"
          state={transformToDispatch}
        >
          <TransformToDispatch
            despacho={despacho}
            id={id!}
            loading={!!loading}
            response={response!}
            setTransformToDispatch={setTransformToDispatch}
          />
        </Modal>
      )}
    </div>
  )
}

export default DetailDispatch
